import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { i18n } from '@nw/shared/config';
import {
  AccountsRefreshAuthTokenProvider,
  clearAuthDomainTokens,
  clearFormsDomainTokens,
  clearPaymentsAuthDomainTokens,
  FileUploaderProvider,
  FormsRefreshTokenProvider,
  PaymentsRefreshAuthTokenProvider,
  StorageUtilsProvider
} from '@nw/shared/data-access';
import { sendGAEventToDataLayer } from '@nw/shared/utils';

import { routes } from '../routes/config';

const App = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        cacheTime: 0
      }
    }
  });

  useEffect(() => {
    sendGAEventToDataLayer({
      event: 'niat_portal_page_visited'
    });
    clearAuthDomainTokens();
    clearPaymentsAuthDomainTokens();
    clearFormsDomainTokens();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <I18nextProvider i18n={i18n}>
          <StorageUtilsProvider initialValues={{}}>
            <AccountsRefreshAuthTokenProvider>
              <PaymentsRefreshAuthTokenProvider>
                <FormsRefreshTokenProvider>
                  <FileUploaderProvider>
                    <Router>
                      <Switch>{routes}</Switch>
                    </Router>
                  </FileUploaderProvider>
                </FormsRefreshTokenProvider>
              </PaymentsRefreshAuthTokenProvider>
            </AccountsRefreshAuthTokenProvider>
          </StorageUtilsProvider>
        </I18nextProvider>
      </HelmetProvider>
    </QueryClientProvider>
  );
};

export default App;
